import { render, staticRenderFns } from "./TextareaAutoExpand.vue?vue&type=template&id=7cace426&scoped=true"
import script from "./TextareaAutoExpand.vue?vue&type=script&lang=js"
export * from "./TextareaAutoExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cace426",
  null
  
)

export default component.exports